import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import InvoiceData from "./BillingData/invoiceData";
import CreditNoteData from "./BillingData/creditNoteData";
import { Breadcrum } from "../../components/Layout/breadcrum";
import { SearchBox } from "../../components/SearchBox";
import AccessDenied from "../../components/AccessDenied";
import { checkPageAuthorized } from "../../redux/reducers/role";
import { POST } from "../../utils/webService";
import { GET_ALL_INVOICES } from "../../utils/ApiUrls";
import { toast } from "react-hot-toast";
import { ScrollNav } from "../../components/ScrollNav";
import { Spinner } from "../../components/Spinner";
import PaginationComponent from "../../components/Pagination";

interface IInvoiceProps {}

interface ITab {
  statusName: string;
  index: number;
}

const Invoice: React.FunctionComponent<IInvoiceProps> = (props) => {
  const navigate = useNavigate();
  const [totalItemCount, setTotalItemCount] = useState<number>(0);
  const [renderingComponents, setRenderingComponents] = useState<number>(0);
  const [isActive, setIsActive] = useState<any>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [invoiceArray, setInvoiceArray] = useState<any>([]);
  const [allInvoiceArray, setAllInvoiceArray] = useState<any>([]);
  const [supportsServerPagination, setSupportsServerPagination] = useState<
    boolean | null
  >(null);
  console.log("invoiceArray", invoiceArray);
  const [creditArray, setCreditArray] = useState<any>([]);

  const getCurrentPath = () => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const location = url;
    const path = location.pathname;
    const pathArray = path.split("/");
    const removedFirstPath = pathArray.slice(1);
    return removedFirstPath;
  };

  const data = getCurrentPath() as string[];
  console.log("🚀 ~ data:", data)

  useEffect(() => {
    if(data[1] === 'invoices') {
      setIsActive(checkPageAuthorized("Invoices"));
    }
  });
  

  const arrayData = [
    { label: "Orders" },
    { label: "Invoice" },
    { label: "Credit Notes" },
    { label: "COD" },
  ];

  const render = (id: any) => {
    if (id === 0) {
      navigate("/billing/orders");
    } else if (id === 1) {
      navigate("/billing/invoices");
    }
    else if (id === 2) {
      navigate("/billing/credit-notes");
    } else if (id === 3) {
      navigate("/billing/cod");
    }
  };

  const fetchInvoices = async (payloads?: any) => {
    try {
      setIsLoading(true);
      const payload =
        payloads ||
        ({
          skip: (currentPage - 1) * itemsPerPage,
          limit: itemsPerPage,
          pageNo: currentPage,
        } as any);

      const { data } = await POST(GET_ALL_INVOICES, payload);
      if (data?.success) {
        const results = data?.data?.[0]?.results || data?.data || [];
        const totalCandidate =
          data?.totalCount ??
          data?.total ??
          data?.data?.[0]?.totalCount ??
          data?.data?.[0]?.total ??
          undefined;

        const hasServerTotal =
          totalCandidate !== undefined &&
          totalCandidate !== null &&
          String(totalCandidate) !== "";

        if (hasServerTotal) {
          setSupportsServerPagination(true);
          setInvoiceArray(results);
          setAllInvoiceArray([]);
          setTotalItemCount(Number(totalCandidate) || 0);
        } else {
          // Fallback: client-side pagination if backend doesn't return totals
          setSupportsServerPagination(false);
          setAllInvoiceArray(results);
          setTotalItemCount(Array.isArray(results) ? results.length : 0);
          const sliced = Array.isArray(results)
            ? results.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )
            : [];
          setInvoiceArray(sliced);
        }
      } else {
        toast.error(data?.message);
      }
    } catch (error: any) {
      console.log(error.message);
      toast.error(error?.message || "Failed to fetch invoices");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // If server pagination is supported, refetch per page.
    // Otherwise fetch once and slice client-side.
    if (supportsServerPagination === false) return;
    fetchInvoices();
  }, [itemsPerPage, currentPage, supportsServerPagination]);

  useEffect(() => {
    if (supportsServerPagination !== false) return;
    const sliced = Array.isArray(allInvoiceArray)
      ? allInvoiceArray.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : [];
    setInvoiceArray(sliced);
  }, [supportsServerPagination, allInvoiceArray, currentPage, itemsPerPage]);

  //on page change index
  const onPageIndexChange = (paginationData: any) => {
    setCurrentPage(paginationData.currentPage);
  };

  // on per page item change
  const onPerPageItemChange = (paginationData: any) => {
    setItemsPerPage(paginationData.itemsPerPage);
    setCurrentPage(1);
  };

  const setScrollIndex = (id: number) => {
    setRenderingComponents(id);
    render(id);
  };

  return (
    <>
      {isActive || isActive === undefined ? (
      <div>
        <Breadcrum label="Billing" />

        <div className="lg:flex justify-between mx-4 lg:mt-2 lg:mb-4">
          <div>
            <ScrollNav
              arrayData={arrayData}
              showNumber={false}
              setScrollIndex={setScrollIndex}
              defaultIndexValue={1}
            />
          </div>
          <div>
            <div>
              {/* <SearchBox label="Search" value="" onChange={() => {}} /> */}
            </div>
          </div>
        </div>
        <div className="customScroll">
          <div className="mx-4">
            {isLoading ? (
              <div className="flex items-center justify-center h-[400px]">
                <Spinner />
              </div>
            ) : (
              <>
                <InvoiceData
                  invoiceData={invoiceArray}
                  fetchInvoices={fetchInvoices}
                />
              </>
            )}
          </div>
          {totalItemCount > 0 && (
            <PaginationComponent
              totalItems={totalItemCount}
              itemsPerPageOptions={[
                10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000,
              ]}
              onPageChange={onPageIndexChange}
              onItemsPerPageChange={onPerPageItemChange}
            />
          )}
        </div>
      </div>

      ) : (
        <div>
          <AccessDenied />
        </div>
      )}
    </>
  );
};

export default Invoice;

// import React, { useState } from "react";
// import { Breadcrum } from "../../components/Layout/breadcrum";
// import { ScrollNav } from "../../components/ScrollNav";
// import { SearchBox } from "../../components/SearchBox";
// import PaginationComponent from "../../components/Pagination";
// import { useNavigate } from "react-router-dom";
// import InvoiceData from "./BillingData/invoiceData";

// interface IInvoiceProps {}

// const Invoice: React.FunctionComponent<IInvoiceProps> = (props) => {
//   const navigate = useNavigate();
//   const [totalItemCount, setTotalItemCount] = useState(10);
//   const [renderingComponents, setRenderingComponents] = useState(0);
//   const arrayData = [
//     { label: "Orders" },
//     { label: "Invoice" },
//     { label: "Credit Note" },
//     { label: "Cod" },
//   ];

//   const render = (id: any) => {
//     if (id === 0) {
//       navigate("/billing/orders");
//     } else if (id === 1) {
//       navigate("/billing/invoices");
//     } else if (id === 2) {
//       navigate("/billing/credit-notes");
//     } else if (id === 3) {
//       navigate("/billing/cod");
//     }
//   };
//   //on page change index
//   const onPageIndexChange = () => {};

//   // on per page item change
//   const onPerPageItemChange = () => {};

//   const setScrollIndex = (id: number) => {
//     setRenderingComponents(id);
//     render(id);
//   };
//   return (
//     <>
//       <div>
//         <Breadcrum label="Billing" />
//         <div className="lg:flex justify-between mx-4 lg:mt-2 lg:mb-4">
//           <div>
//             <ScrollNav
//               arrayData={arrayData}
//               showNumber={false}
//               setScrollIndex={setScrollIndex}
//               defaultIndexValue={1}
//             />
//           </div>
//           <div>
//             <div>
//               <SearchBox label="Search" value="" onChange={() => {}} />
//             </div>
//           </div>
//         </div>
//         <div className="mx-4">
//           <InvoiceData />
//         </div>

//         {totalItemCount > 0 && (
//           <PaginationComponent
//             totalItems={totalItemCount}
//             itemsPerPageOptions={[10, 20, 30, 50]}
//             onPageChange={onPageIndexChange}
//             onItemsPerPageChange={onPerPageItemChange}
//           />
//         )}
//       </div>
//     </>
//   );
// };

// export default Invoice;
